import * as types from '../constants/actionTypes';
import initialState from './initialState';
import * as list from '../utils/list';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function floatingTaskReducer(state = initialState.floatingTasks, action) {
    let newState = state;

    switch (action.type) {
        case types.CREATE_FLOATING_TASK:
            if (action.status === 'success') {
                newState = createFloatingTask(state, action.data);
            }
            if (action.status === 'failure') {
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }

            return newState;

        case types.CREATE_FLOATING_TIMER:
            if (action.status === 'success') {
                newState = createTimer(state, action.data);
            }
            if (action.status === 'failure') {
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.DELETE_FLOATING_TASK:
            if (action.status === 'success') {
                newState = deleteFloatingTask(state, action.data);
            }
            if (action.status === 'failure') {
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.IS_DELETABLE_FLOATING_TASK:
            if (action.status === 'success') {
                let deletableFloatingTasks = state.deletableFloatingTasks;
                deletableFloatingTasks[action.data.id] = action.data.value;

                newState = Object.assign({}, state, {
                    deletableFloatingTasks: deletableFloatingTasks
                });
            }
            if (action.status === 'failure') {
                newState = Object.assign({}, state, {
                    error: action.data,
                });
            }
            return newState;

        case types.INVALIDATE_FLOATING_TASK:
            if (action.status === 'success') {
                newState = invalidateFloatingTask(state, action.data);
            }
            if (action.status === 'failure') {
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_ALL_FLOATING_TASKS:
            if (action.status === undefined) {
                newState = Object.assign({}, state, {
                    loading: true
                });
            }
            if (action.status === 'success') {
                newState = Object.assign({}, state, {
                    allFloatingTasks: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure') {
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.MERGE_FLOATING_TASK_EXISTING:
            if (action.status === 'success') {
                newState = mergeFloatingTaskExisting(state, action.data);
            }
            if (action.status === 'failure') {
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.MERGE_FLOATING_TASK_NEW:
            if (action.status === 'success') {
                newState = mergeFloatingTaskNew(state, action.data);
            }
            if (action.status === 'failure') {
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.PM_LOAD_ALL_FLOATING_TASKS:
            if (action.status === undefined) {
                newState = Object.assign({}, state, {
                    loading: true
                });
            }
            if (action.status === 'success') {
                newState = Object.assign({}, state, {
                    adminFloatingTasks: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure') {
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.PMO_LOAD_ALL_FLOATING_TASKS:
            if (action.status === undefined) {
                newState = Object.assign({}, state, {
                    loading: true
                });
            }
            if (action.status === 'success') {
                newState = Object.assign({}, state, {
                    adminFloatingTasks: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure') {
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.REASSIGN_FLOATING_TASK:

            if (action.status === 'success') {
                newState = reassignFloatingTask(state, action.data);
            }
            if (action.status === 'failure') {
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.RETURN_FLOATING_TASK:

            if (action.status === 'success') {
                newState = returnFloatingTask(state, action.data);
            }
            if (action.status === 'failure') {
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.VALIDATE_FLOATING_TASK:

            if (action.status === 'success') {
                newState = validateFloatingTask(state, action.data);
            }
            if (action.status === 'failure') {
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        default:
            return state;
    }
}

function createFloatingTask(state, floatingTask) {
    return Object.assign({}, state, {
        loading: false,
        allFloatingTasks: [...state.allFloatingTasks, floatingTask]
    });
}

function createTimer(state, logEntry) {
    return Object.assign({}, state, {
        loading: false,
    });
}

function deleteFloatingTask(state, floatingTaskID) {
    let floatingTaskList = state.allFloatingTasks;
    let index = list.findIndexByID(floatingTaskList, floatingTaskID);
    floatingTaskList = list.remove(floatingTaskList, index);

    let adminFloatingTaskList = state.adminFloatingTasks;
    index = list.findIndexByID(adminFloatingTaskList, floatingTaskID);
    adminFloatingTaskList = list.remove(adminFloatingTaskList, index);

    return Object.assign({}, state, {
        loading: false,
        adminFloatingTasks: adminFloatingTaskList,
        allFloatingTasks: floatingTaskList
    });
}

function invalidateFloatingTask(state, floatingTaskID) {
    // TODO
    let newState = Object.assign({}, state, {
        loading: false
    });
    return newState;
}

function mergeFloatingTaskExisting(state, data) {
    let floatingTaskIndex = list.findIndexByID(state.adminFloatingTasks, data.floatingTaskID);
    let adminFloatingTasks = list.remove(state.adminFloatingTasks, floatingTaskIndex);

    let newState = Object.assign({}, state, {
        loading: false,
        adminFloatingTasks: adminFloatingTasks
    });
    return newState;
}

function mergeFloatingTaskNew(state, data) {
    let floatingTaskIndex = list.findIndexByID(state.adminFloatingTasks, data.floatingTaskID);
    let adminFloatingTasks = list.remove(state.adminFloatingTasks, floatingTaskIndex);

    let newState = Object.assign({}, state, {
        loading: false,
        adminFloatingTasks: adminFloatingTasks
    });
    return newState;
}

function pmoDeleteFloatingTask(state, floatingTaskID) {
    return deleteFloatingTask(state, floatingTaskID);
}

function reassignFloatingTask(state, data) {
    let floatingTaskIndex = list.findIndexByID(state.adminFloatingTasks, data.floatingTaskID);
    let adminFloatingTasks = list.remove(state.adminFloatingTasks, floatingTaskIndex);

    let newState = Object.assign({}, state, {
        loading: false,
        adminFloatingTasks: adminFloatingTasks
    });
    return newState;
}

function returnFloatingTask(state, floatingTaskID, message) {
    // TODO
    let newState = Object.assign({}, state, {
        loading: false
    });
    return newState;
}

function validateFloatingTask(state, floatingTaskID) {
    // TODO
    let newState = Object.assign({}, state, {
        loading: false
    });
    return newState;
}


/** WEBPACK FOOTER **
 ** ./src/app/reducers/floatingTaskReducer.js
 **/